import React from "react";
import PropTypes from "prop-types";
//widgets
import withStyles from "@material-ui/core/styles/withStyles";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import Grow from "@material-ui/core/Grow";
import TextField from "@material-ui/core/TextField";
//icons
import Search from "@material-ui/icons/Search";
import Download from "@material-ui/icons/GetApp";
import ViewColumn from "@material-ui/icons/ViewColumn";
import FilterList from "@material-ui/icons/FilterList";
import Clear from "@material-ui/icons/Clear";
//local
import { Select } from "../";

class tgToolbar extends React.PureComponent {
  state = {
    menuAnchor: null,
    menuContent: null,
    search: false,
  };

  openMenu = name => event => {
    this.setState({ menuAnchor: event.currentTarget, menuContent: name });
  };

  closeMenu = () => {
    this.setState({ menuAnchor: null });
  };

  showSearch = () => {
    this.setState({ search: true });
    document.addEventListener("keydown", this.onKeyDown, false);
  };

  hideSearch = () => {
    this.setState({ search: false });
    this.props.updateSearch(null);
    document.removeEventListener("keydown", this.onKeyDown, false);
  };

  onKeyDown = event => {
    if (event.keyCode === 27) {
      this.hideSearch();
    }
  };

  updateSearch = event => {
    this.props.updateSearch(event.target.value);
  };

  generateUtf16Url = str => {
    var charCode,
      byteArray = [];
    byteArray.push(255, 254);
    for (var i = 0; i < str.length; ++i) {
      charCode = str.charCodeAt(i);
      byteArray.push(charCode & 0xff);
      byteArray.push((charCode / 256) >>> 0);
    }
    const blob = new Blob([new Uint8Array(byteArray)], {
      type: "text/csv;charset=UTF-16LE;",
    });
    return URL.createObjectURL(blob);
  };

  csvDownload = () => {
    const { shownData, columns, title } = this.props;
    const cols = columns.filter(col => !col.options.download);
    const CSVHead =
      cols.reduce((soFar, col) => soFar + col.name + "\t", "").slice(0, -1) +
      "\n";
    const CSVBody = shownData
      .map(row => {
        return cols
          .map(col =>
            typeof col.options.customValue === "function"
              ? col.options.customValue(row[col.key], row)
              : row[col.key]
          )
          .join("\t");
      })
      .join("\n");

    let CSVLink = document.createElement("a");

    CSVLink.href = this.generateUtf16Url(CSVHead + CSVBody);
    CSVLink.target = "_blank";
    CSVLink.download = title + ".csv";
    document.body.appendChild(CSVLink);
    CSVLink.click();
    CSVLink.parentNode.removeChild(CSVLink);
  };

  clickColumn = (column, index) => {
    const col = Object.assign({}, column);
    col.options.hide.display = !col.options.hide.display;
    this.props.updateColumn(col, index);
  };

  render() {
    const {
      classes,
      title,
      renderTitle,
      columns,
      options,
      data,
      updateFilter,
    } = this.props;
    const { menuAnchor, menuContent, search } = this.state;

    return (
      <div className={classes.root}>
        <Toolbar className={classes.toolbar}>
          <div className={classes.title}>
            {search ? (
              <Grow appear in={true} timeout={300}>
                <div className={classes.searchMain}>
                  <Search className={classes.searchIcon} />
                  <TextField
                    className={classes.searchText}
                    autoFocus={true}
                    InputProps={{
                      "aria-label": "Search Table",
                      classes: {
                        input: classes.textWhite,
                        underline: classes.inputUnderline,
                      },
                    }}
                    onChange={this.updateSearch}
                    fullWidth={true}
                  />
                  <IconButton
                    className={classes.clearIcon}
                    onClick={this.hideSearch}
                  >
                    <Clear />
                  </IconButton>
                </div>
              </Grow>
            ) : (
              <div className={classes.titleText}>
                {renderTitle ? renderTitle : title}
              </div>
            )}
          </div>
          <div className={classes.tools}>
            {options.search ? (
              <Tooltip title="Search" onClick={this.showSearch}>
                <IconButton className={classes.toolButton}>
                  <Search />
                </IconButton>
              </Tooltip>
            ) : null}
            {options.download ? (
              <Tooltip title="Download CSV" onClick={this.csvDownload}>
                <IconButton className={classes.toolButton}>
                  <Download />
                </IconButton>
              </Tooltip>
            ) : null}
            {options.colSelect ? (
              <Tooltip
                title="Show Columns"
                onClick={this.openMenu("Show Columns")}
              >
                <IconButton className={classes.toolButton}>
                  <ViewColumn />
                </IconButton>
              </Tooltip>
            ) : null}
            {options.filter ? (
              <Tooltip title="Filter" onClick={this.openMenu("Filters")}>
                <IconButton className={classes.toolButton}>
                  <FilterList />
                </IconButton>
              </Tooltip>
            ) : null}

            <Menu
              anchorEl={menuAnchor}
              open={menuAnchor !== null}
              onClose={this.closeMenu}
            >
              <div className={classes.menuTitle}>{menuContent}</div>
              {menuContent === "Filters" ? (
                <div className={classes.selectRoot}>
                  {columns.reduce(
                    (acc, col, index) =>
                      acc.concat(
                        !col.options.hide.filter ? (
                          <div
                            key={col.key + "_" + index}
                            className={classes.selectFormControl}
                          >
                            <Select
                              label={col.name}
                              multiple
                              value={col.filters.slice()}
                              onChange={event =>
                                updateFilter(index, event.target.value)
                              }
                              menuItems={[
                                ...new Set(
                                  data
                                    .map(d =>
                                      typeof col.options.customValue ===
                                      "function"
                                        ? col.options.customValue(d[col.key], d)
                                        : d[col.key]
                                    )
                                    .sort((a, b) =>
                                      a && typeof a.localeCompare === "function"
                                        ? a.localeCompare(b, undefined, {
                                            sensitivity: "base",
                                            numeric: true,
                                          })
                                        : b &&
                                          typeof b.localeCompare === "function"
                                        ? -b.localeCompare(a, undefined, {
                                            sensitivity: "base",
                                            numeric: true,
                                          })
                                        : a - b
                                    )
                                ),
                              ]}
                            />
                          </div>
                        ) : (
                          []
                        )
                      ),
                    []
                  )}
                </div>
              ) : (
                columns.reduce(
                  (acc, col, index) =>
                    acc.concat(
                      !col.options.hide.colSelect ? (
                        <MenuItem
                          key={col.key + "-" + index}
                          onClick={() => this.clickColumn(col, index)}
                        >
                          <Checkbox
                            checked={!col.options.hide.display}
                            color="primary"
                            tabIndex={-1}
                            disableRipple
                          />
                          <ListItemText primary={col.name} />
                        </MenuItem>
                      ) : (
                        []
                      )
                    ),
                  []
                )
              )}
            </Menu>
          </div>
        </Toolbar>
      </div>
    );
  }
}

tgToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  renderTitle: PropTypes.node,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
};

const styles = theme => ({
  root: {
    width: "100%",
  },
  toolbar: {
    minHeight: "48px",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  title: {
    flex: "1 1 auto",
    textAlign: "center",
    [theme.breakpoints.up("sm")]: {
      textAlign: "left",
    },
  },
  titleText: {
    textTransform: "capitalize",
    fontSize: "1.3125rem",
  },
  tools: {
    flex: "1 1 auto",
    textAlign: "center",
    [theme.breakpoints.up("sm")]: {
      textAlign: "right",
    },
  },
  toolButton: {
    color: "inherit",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(.8),
    },
  },
  menuTitle: {
    margin: theme.spacing(1) + "px " + theme.spacing(2) + "px",
  },
  selectRoot: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
    height: "80%",
    justifyContent: "space-between",
    marginLeft: theme.spacing(2),
  },
  selectFormControl: {
    flex: "1 1 calc(50% - 24px)",
    marginRight: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  searchMain: {
    display: "flex",
    flex: "1 0 auto",
  },
  searchIcon: {
    marginTop: "10px",
    marginRight: "8px",
  },
  searchText: {
    flex: "0.8 0",
  },
  textWhite: {
    color: "#FFFFFF",
  },
  inputUnderline: {
    "&:after": {
      backgroundColor: "#FFFFFF",
    },
  },
  clearIcon: {
    color: "#FFFFFF",
    "&:hover": {
      color: "#FF0000",
    },
  },
});

export default withStyles(styles)(tgToolbar);
